import { StyledDirectionTable } from "../../../styles/StyledDecision/StyledContent";
import DeleteIcon from "../../../assets/img/icons/delete.svg";
import EditIcon from "../../../assets/img/icons/edit-black.svg";

export type DecisionChunk = {
	id: number;
	title: string;
	label: {
		id: number;
		name: string;
	};
	description: string;
	order: number;
};

type DecisionChunkProps = {
	chunk: DecisionChunk;
	setDeleteId: (id: number) => void;
	openDeleteModal: () => void;
	setEditId: (id: number) => void;
	openEditModal: () => void;
};

export const DecisionChunk = (props: DecisionChunkProps) => {
	const { chunk, setDeleteId, openDeleteModal, setEditId, openEditModal } = props;
	return (
		<StyledDirectionTable>
			<span>{chunk.order}</span>
			<span>{chunk.title}</span>
			<span>{chunk.label.name}</span>

			<span>
				<img
					onClick={() => {
						setEditId(chunk.id);
						openEditModal();
					}}
					src={EditIcon}
					alt={EditIcon}
					role="img"
				/>
				<img
					onClick={() => {
						setDeleteId(chunk.id);
						openDeleteModal();
					}}
					src={DeleteIcon}
					alt={DeleteIcon}
					role="img"
				/>
			</span>
		</StyledDirectionTable>
	);
};
